<div class="card makery-card makery-card-visible makery-card-reservation-note
{{(reservation.reservationStatus == 'SUCCEEDED')?'makery-card-success':'makery-card-accepted'}}">
  <div class="card-header">
    <div class="row">
      <div class="col-md-7 col-sm-10 col">
        <p class="card-title">{{'note.header' | translate}}</p>
      </div>
      <div class="col-md-5 col-sm-2 col makery-control">
        <button class="btn btn-simple btn-tooltip mr-2 btn-hide pr-0 pl-3 "
                data-animation="true"
                data-container="body"
                placement="bottom"
                tooltip="{{'note.edit' | translate}}"
                (click)="setEdit()">
          <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="!editNote; else noteEditor">
      <p *ngIf="reservation.notes.length < 1; else note">{{'note.notExist' | translate}}</p>
      <ng-template #note>{{reservation.notes[reservation.notes.length - 1].message}}</ng-template>
    </div>
    <ng-template #noteEditor>
      <form class=" form-horizontal" id="TypeValidation" [formGroup]="messageForm" (ngSubmit)="addNote()">
        <div class=" row">
          <div class=" col-sm-12 col">
            <div class=" form-group" [ngClass]="{ 'has-danger': ((focusTouched || type) && messageF.message.errors) ||(messageF.message.value != '' &&messageF.message.errors),
                                                'has-success': !messageF.message.errors }">
                  <textarea class=" form-control" name="required" required="" formControlName="message"
                            (focus)="focusTouched = true" type="text"></textarea>
              <label class="error"
                     *ngIf=" ((focusTouched || type) && messageF.message.errors) || (messageF.message.value != '' && messageF.message.errors)">This
                field is required.</label>
            </div>
          </div>
          <div class="col-sm-12 col">
            <button class=" btn btn-primary" type="submit">{{'general.send' | translate}}</button>
          </div>
        </div>
      </form>
    </ng-template>
  </div>
</div>
